import { defineComponent as _defineComponent } from 'vue';
import { ref, onMounted } from 'vue';
import { getDynamicComponent } from '@/components';
export default /*#__PURE__*/_defineComponent({
  __name: 'resource',
  props: {
    item: {
      type: Object,
      required: true
    },
    columnDefs: {
      type: Object,
      default: () => {}
    },
    size: {
      type: String,
      default: 'lg'
    },
    searchValue: {
      type: [String, Array],
      default: ''
    },
    additionalData: {
      type: Object,
      default: () => {}
    },
    isNestedTable: {
      type: Boolean,
      default: false
    },
    isParentSelected: {
      type: Boolean,
      default: false
    },
    isBulkSelectAll: {
      type: Boolean,
      default: false
    }
  },
  emits: ['row:change'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const listRowComponent = ref(null);
    onMounted(() => {
      listRowComponent.value = getDynamicComponent(`uc/list-row/${props.item.type}`);
    });
    return {
      __sfc: true,
      emit,
      props,
      listRowComponent
    };
  }
});